import React, { Component } from "react";
import { Box } from "reactjs-admin-lte";
import {
  Form,
  FormGroup,
  Breadcrumb,
  Button,
  Tabs,
  Tab,
  FormControl,
} from "react-bootstrap";
import SelectDate from "component/element/SelectDate";
import SWTCustomerEditModal from "../workdoc/SWTCustomerEditModal";
import WorkdocStore from "../../stores/WorkdocStore";
import Select from "react-select";
import Moment from "moment";
import FontAwesome from "react-fontawesome";
import CashflowStore from "../../stores/CashflowStore";
import withSizes from "react-sizes";
import { momentHelper } from "./helpers";
const yTh = parseInt(Moment().format("YYYY")) + 543;
class ReportSubscription extends Component {
  constructor(props) {
    super(props);

    const optionsYear = [];
    const year = momentHelper.getYear();

    for (var i = yTh; i >= 2557; i--) {
      optionsYear.push({
        value: i,
        label: i,
      });
    }

    this.state = {
      loading: false,
      showTb: true,
      year: year,
      month: "00",
      optionsYear: optionsYear,
      defaultYear: yTh,
      data: this.newEmptyRow(12),
      dataInfo: [],
      curInfo: false,
      catId: "fasttrack",
      showEdit: false,
      customerName: "",
      catList: [
        { label: "ระบบช่วงล่าง", value: "fasttrack" },
        { label: "รถบรรทุก", value: "truck" },
      ],
      tabKey: 0,
    };
  }

  componentDidMount() {}

  componentWillReceiveProps(newProps) {}

  newEmptyRow(number = 1) {
    return new Array(number).fill(null).map((item, index) => {
      return {
        customer_name: "test",
        system: "ช่วงล่าง",
        date: "10/09/2564",
        test: "test",
      };
    });
  }

  getNumberFormat(value) {
    let _val =
      value === "" || value === null || value === undefined || isNaN(value)
        ? 0
        : value;
    _val = parseFloat(_val);
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
  }

  loadData(year) {
    CashflowStore.loadCashflowSummaryYearRecord(year - 543, (result) => {
      this.setState({ data: result.data, loading: false });
    });
  }
  onMonthChange(month) {
    let { year } = this.state;
    this.setState({ month: month });
    this.loadData(year, month);
  }

  onYearChange(year) {
    let { month } = this.state;
    this.setState({ year: year });
    this.loadData(year, month);
  }
  onTabsSelect(e) {
    this.setState({ tabKey: e });
  }

  onCatChange(val) {
    this.setState({
      catId: val.value,
    });
  }

  onTextChange(e) {
    let { customerName } = this.state;
    customerName = e.target.value;
    this.setState({ customerName: customerName });
  }

  onNewClick() {
    this.setState({ showEdit: true });
  }

  onClearClick() {
    this.setState({ query: "", curPage: 0, catSelect: null });
    this.loadCustomerList("-1");
  }

  onSaveClick(postData, completeFunc) {
    WorkdocStore.saveCustomer(postData, completeFunc, (error) => {});
  }

  onDelClick(item, completeFunc) {
    //console.log('postData',postData)
    WorkdocStore.delCustomer(item.customer_id, completeFunc, (error) => {});
  }

  onAfterSubmit(postData) {
    //this.onClearClick()
  }

  onAfterDelete() {
    this.onClearClick();
  }
  onSearchAfterSubmit(postData) {
    this.refs.notificationSystem.addNotification({
      title: "แจ้งเตือน",
      message: 'เพิ่มข้อมูลลูกค้า "' + postData.name + '"" เรียบร้อย',
      level: "info",
      position: "tc",
    });
    this.setState({ query: postData.name });
    this.loadCustomerList(postData.cat_id, postData.name);
  }

  renderRowData() {
    let { data } = this.state;
    if (data.length === 0) {
      return (
        <tr>
          <td colSpan={6}>ไม่พบข้อมูล</td>
        </tr>
      );
    }
    return data.map((item, index) => {
      return (
        <tr key={index}>
          <td className="text-center">{item.customer_name}</td>
          <td className="text-center">{item.system}</td>
          <td className="text-center">{item.date}</td>
          <td className="text-center">{item.test}</td>
          <td className="text-center">{item.test}</td>
          <td className="text-center">{item.test}</td>
          <td className="text-center">{item.test}</td>
          <td className="text-center">{item.test}</td>
          <td className="text-center">{item.test}</td>
          <td className="text-center">{item.test}</td>
          <td className="text-center">{item.test}</td>
          <td className="text-center">{item.test}</td>
        </tr>
      );
    });
  }

  renderTable() {
    return (
      <div className="table-responsive">
        <table
          className="table table-responsive table-hover table-bordered-solid table-tool"
          style={{ marginBottom: "0" }}
        >
          <thead>
            <tr>
              <th className="text-center" style={{ width: "30px" }}>
                ชื่อลูกค้า
              </th>
              <th className="text-center" style={{ width: "80px" }}>
                ระบบ
              </th>
              <th className="text-center" style={{ width: "80px" }}>
                วันเริ่มใช้งาน
              </th>
              <th className="text-center " style={{ width: "80px" }}>
                วันหมดอายุ
              </th>
              <th className="text-center " style={{ width: "80px" }}>
                จำนวน Licence
              </th>
              <th className="text-center" style={{ width: "80px" }}>
                จำนวนครั้งต่ออายุ
              </th>
              <th className="text-center" style={{ width: "80px" }}>
                มัดจำ
              </th>
              <th className="text-center" style={{ width: "80px" }}>
                ค่าแรกเข้าเก็บได้
              </th>
              <th className="text-center" style={{ width: "80px" }}>
                ค่าแรกเข้าค้างจ่าย
              </th>
              <th className="text-center" style={{ width: "80px" }}>
                ค่ารายปี
              </th>
              <th className="text-center" style={{ width: "80px" }}>
                เก็บเงินได้ทั้งหมด
              </th>
              <th className="text-center" style={{ width: "80px" }}>
                สถานะ
              </th>
            </tr>
          </thead>
          <tbody>{this.renderRowData()}</tbody>
          <tfoot></tfoot>
        </table>
      </div>
    );
  }

  render() {
    let { loading, showTb, tabKey, showEdit } = this.state;
    let { isMobile } = this.props;
    return (
      <div>
        <div style={{ display: showTb ? "" : "none" }}>
          <Box loading={loading}>
            <Box.Header border={true}>
              <Box.Title></Box.Title>
              <Box.Tools></Box.Tools>
            </Box.Header>
            <Box.Body>
              <Form inline>
                <FormGroup style={{ marginBottom: "5px" }}>
                  <SelectDate
                    wholeYear={true}
                    year={this.state.year}
                    month={this.state.month}
                    onMonthChange={this.onMonthChange.bind(this)}
                    onYearChange={this.onYearChange.bind(this)}
                  />
                </FormGroup>{" "}
                <FormGroup style={{ marginBottom: "5px", width: "150px" }}>
                  <Select
                    clearable={false}
                    name="form-field-name"
                    value={this.state.catId}
                    options={this.state.catList}
                    onChange={this.onCatChange.bind(this)}
                  />
                </FormGroup>{" "}
                <FormGroup style={{ marginBottom: "5px" }}>
                  <FormControl
                    readOnly={""}
                    value={this.state.customerName}
                    onChange={this.onTextChange.bind(this)}
                    placeholder="ค้นหาชื่อบริษัท"
                  />
                </FormGroup>
                <FormGroup
                  className="pull-right"
                  style={{ marginBottom: "5px" }}
                >
                  <Button onClick={this.onNewClick.bind(this)}>
                    <FontAwesome name="plus" />
                    &nbsp;เพิ่มลูกค้า
                  </Button>
                </FormGroup>
              </Form>
              <Tabs
                onSelect={this.onTabsSelect.bind(this)}
                activeKey={tabKey}
                id=""
              >
                <Tab eventKey={0} title={"ทั้งหมด"}>
                  <Box>
                    <Box.Body>{this.renderTable()}</Box.Body>
                  </Box>
                </Tab>
                <Tab eventKey={1} title={"รอเก็บเงิน"}>
                  <Box>
                    <Box.Body>{}</Box.Body>
                  </Box>
                </Tab>
                <Tab eventKey={2} title={"แจ้งเตือนแล้ว"}>
                  <Box>
                    <Box.Body>{}</Box.Body>
                  </Box>
                </Tab>
                <Tab eventKey={3} title={"เก็บเงินแล้ว"}>
                  <Box>
                    <Box.Body>{}</Box.Body>
                  </Box>
                </Tab>
                <Tab eventKey={4} title={"ขอผ่อน/ส่วนลด"}>
                  <Box>
                    <Box.Body>{}</Box.Body>
                  </Box>
                </Tab>
                <Tab eventKey={5} title={"ยกเลิกใช้งาน"}>
                  <Box>
                    <Box.Body>{}</Box.Body>
                  </Box>
                </Tab>
              </Tabs>
            </Box.Body>
          </Box>
          <SWTCustomerEditModal
            ref={"wageitemedit"}
            show={showEdit}
            editTitle={"ลูกค้า"}
            accountEditView={this.state.account_edit_view}
            onSaveClick={this.onSaveClick.bind(this)}
            onDelClick={this.onDelClick.bind(this)}
            onAfterDelete={this.onAfterDelete.bind(this)}
            onAfterSubmit={this.onAfterSubmit.bind(this)}
            onSearchAfterSubmit={this.onSearchAfterSubmit.bind(this)}
            onHide={() => {
              this.setState({ showEdit: false });
            }}
          />
        </div>
      </div>
    );
  }
}

ReportSubscription.defaultProps = {};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 480,
});

export default ReportSubscription =
  withSizes(mapSizesToProps)(ReportSubscription);



// WEBPACK FOOTER //
// ./src/view/report/ReportSubscription.js